// #ux-redesign-start: InboxViewList — copia del de Doctors limitada a system
// folders. Sin trash/folders custom (Patients no tiene esos endpoints).
// Infinite scroll, empty state y reset de selección al cambiar de box
// preservados 1:1 del patrón Doctors.
// ─────────────────────────────────────────────────────────────────────────────
import React, { Fragment, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from 'react-translate';
import { ListGroup } from 'reactstrap';

import {
  actionSetSelectedMessages,
  actionGetMessagesScroll,
} from 'store/actions/messagesActions';

import InboxViewListItem from './InboxViewListItem';

const InboxViewList = ({ mobile, t }) => {
  const dispatch = useDispatch();
  const messageListRef = useRef();

  const { inbox, outbox, prioritybox, loading, box } = useSelector(
    (state) => state.messagesReducer
  );

  const currentList = (() => {
    if (box === 'outbox') return outbox;
    if (box === 'priority') return prioritybox;
    return inbox;
  })();

  // Reset selección al cambiar de box.
  useEffect(() => {
    dispatch(actionSetSelectedMessages([]));
  }, [dispatch, box]);

  // Scroll top al cambiar de box.
  useEffect(() => {
    if (messageListRef.current) messageListRef.current.scrollTop = 0;
  }, [box]);

  // Infinite scroll — saga decide a qué bucket pertenece la siguiente página.
  useEffect(() => {
    const inboxR = messageListRef;
    const infinityScroll = (e) => {
      if (
        Math.round(e.target.offsetHeight + e.target.scrollTop) >=
        e.target.scrollHeight - 80
      ) {
        const searcher = document.getElementById('inbox-searcher');
        const search = searcher && searcher.value ? searcher.value : null;
        dispatch(actionGetMessagesScroll(search));
      }
    };
    if (inboxR.current) {
      inboxR.current.addEventListener('scroll', infinityScroll);
    }
    return () => {
      if (inboxR.current) {
        inboxR.current.removeEventListener('scroll', infinityScroll);
      }
    };
  }, [dispatch]);

  if (box !== 'inbox' && box !== 'outbox' && box !== 'priority') {
    return <></>;
  }

  return (
    <Fragment>
      <div ref={messageListRef} className="inbox-view-list overflow-auto">
        <ListGroup className="inbox-list-container mb-2">
          {box === 'inbox' &&
            inbox?.messages?.length > 0 &&
            inbox.messages.map((item, key) => (
              <InboxViewListItem item={item} key={key} mobile={mobile} />
            ))}
          {box === 'outbox' &&
            outbox?.messages?.length > 0 &&
            outbox.messages.map((item, key) => (
              <InboxViewListItem item={item} key={key} mobile={mobile} />
            ))}
          {box === 'priority' &&
            prioritybox?.messages?.length > 0 &&
            prioritybox.messages.map((item, key) => (
              <InboxViewListItem item={item} key={key} mobile={mobile} />
            ))}

          {currentList &&
            Array.isArray(currentList.messages) &&
            currentList.messages.length === 0 &&
            loading === false && (
              <div className="inbox-empty-state">
                {t('inbox-empty') || 'No messages'}
              </div>
            )}
        </ListGroup>
      </div>
    </Fragment>
  );
};

export default translate('messages')(InboxViewList);
// #ux-redesign-end
